
import axios from 'axios';

var api = require('../../Common/Config');
var BANK_LIST = 'api/listBanksForAPI';
export const postAction = () =>{

    return { type:"Increment",
        payload:[
            {
                udis:1,
                name:"sahan"
            },
            {
                udis:2,
                name:"sameera"
            },
        ]
    }
}
export const fetchPosts=()=>dispatch=>{
    axios.get("https://jsonplaceholder.typicode.com/posts?_limit=5")
    .then(res=>{
      dispatch({
        type:"FETCH_BUTTON_CLICKED",
        payload:res.data
      })
    })
}

export const BankList=()=>dispatch=>{
    axios.get(api.HOST+BANK_LIST,{            
        headers: {
          'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      })
    .then(res=>{
      dispatch({
        type:"BANK_LIST",
        payload:res.data
      })
    })
}

export const postAction2 = () =>{

    return { type:"Decrement",
        payload:[
            {
                udis:1,
                name:"Nsahan"
            },
            {
                udis:2,
                name:"Nsameera"
            },
        ]
    }
}